import { useEffect, useState } from 'react'

const useToggle = (keys, type = 'single', defaultCase = false) => {
  const [isOpen, setIsOpen] = useState({})

  useEffect(() => {
    let obj = {}
    keys.map((x) => {
      obj[x] = defaultCase
      return x
    })
    setIsOpen(obj)
  }, [keys])

  const onClick = (key) => {
    if (type === 'single') {
      setIsOpen((prev) => ({ [key]: !prev[key] }))
    } else if (type === 'multi') {
      setIsOpen((prev) => ({ ...prev, [key]: !prev[key] }))
    }
  }

  return [isOpen, onClick]
}

export default useToggle
